<ng-container *ngIf="products.length > 0">
  <div *ngIf="!isNewFlowCheckout" class="mp-fab cart-fab pointer" data-cy="cartFab" (click)="openShoppingCart()">
    <span class="mp-badge mp-badge--light item-quantity">{{products.length}}</span>
    <button class="mp-button mp-fab-button mp-button--danger">
      <mp-icon name="cart"></mp-icon>
    </button>
  </div>

  <div data-cy="cartFab" *ngIf="isNewFlowCheckout" class="new-cart-bar" [class.new-design-font]="isNewFlowCheckout" (click)="openShoppingCart()">
    <div class="new-cart-bar__left">
      <img class="new-cart-bar__icon" src="assets/icon/cart-bar.svg" alt="cart" />
      <span class="new-cart-bar__badge">{{ products.length }}</span>
    </div>

    <span class="new-cart-bar__label" translate>View cart</span>

    <span class="new-cart-bar__total">{{ cartTotal | multiCurrency }}</span>
  </div>
</ng-container>
